<template>
    <div class="node-area-edit" v-if="shows">
        <v-btn x-small icon color="primary" @click.stop.capture="setIsEdit">
            <v-icon>mdi-pencil-circle</v-icon>
        </v-btn>
    </div>
</template>

<script>
export default {
    props: {
        /** @type {import('vue').PropType<'form'|'sign'|'view'|'done''>} */
        mode: { type: String, default: "form" },
        active: { type: Boolean, default: false },
    },
    computed: {
        shows() {
            if (!this.active) return false;
            if (this.mode != "form") return false;

            return true;
        },
    },
    methods: {
        setIsEdit() {
            this.$store.commit("employment/form/node/setIsEdit", true);
        },
    },
};
</script>

<style lang="scss" scoped>
.node-area-edit {
    position: absolute;
    left: calc(100% + 16px);
    top: 50%;
    transform: translateY(-50%);
}
</style>
